import {MyAccountUploadDocumentsExternalLinkHandler} from "../../my-account-upload-documents.external-link-handler";

export class OntarioMyAccountUploadDocumentsExternalLinkHandler extends MyAccountUploadDocumentsExternalLinkHandler {
    protected get _hideCloseButton(): boolean {
        return true;
    }
}